import { useEffect, useState } from "react";
import { Building2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMessage } from "@/lib/api";
import { storage } from "@/lib/offline/storage";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { ROLE_LABEL } from "@/lib/labels";
import { selectCls } from "@/pages/Take5New";

// Switching keeps the session; local cache is per workplace so it is emptied (pending items stay tagged).
const switchTo = async (orgId) => {
  await api.post("/auth/workplace", { org_id: orgId });
  await storage.clear("cache");
  await storage.del("meta", "lastSync");
  window.location.assign("/");
};

export const WorkplaceSwitcher = ({ testId = "workplace-switcher", always = false }) => {
  const [list, setList] = useState([]);
  useEffect(() => { api.get("/auth/workplaces").then((r) => setList(r.data)).catch(() => {}); }, []);
  if (!always && list.length < 2) return null;
  const current = list.find((w) => w.current);
  return (
    <label className="mt-3 block text-xs text-muted-foreground">
      <span className="flex items-center gap-1"><Building2 className="h-3.5 w-3.5" /> Workplace actif</span>
      <select data-testid={testId} className={`${selectCls} mt-1 h-10 text-sm`} value={current?.org_id || ""}
        onChange={(e) => switchTo(e.target.value).catch((err) => toast.error(errMessage(err)))}>
        {list.map((w) => <option key={w.org_id} value={w.org_id} title={`${w.name} · ${ROLE_LABEL[w.role]}`}>{w.name}</option>)}
      </select>
    </label>
  );
};

export const JoinWorkplace = () => {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const join = async () => {
    setBusy(true);
    try {
      const r = await api.post("/auth/join", { join_code: code });
      toast.success(`Vous avez rejoint ${r.data.name} (Opérateur). Choisissez-le dans « Workplace actif ».`);
      setCode("");
      setTimeout(() => window.location.reload(), 800);
    } catch (e) { toast.error(errMessage(e)); } finally { setBusy(false); }
  };
  return (
    <div className="flex flex-col gap-2 sm:flex-row" data-testid="join-workplace">
      <Input data-testid="join-workplace-code" value={code} onChange={(e) => setCode(e.target.value)} placeholder="Code du workplace (ex. DEMO-SAFE)" className="h-11" />
      <Button data-testid="join-workplace-submit" disabled={!code.trim() || busy} onClick={join} className="h-11">{busy && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Rejoindre</Button>
    </div>
  );
};
